"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultState = exports.changeRiskLevel = exports.changeName = exports.CHANGE_RISK_LEVEL = exports.CHANGE_NAME = exports.BUILD_NAME = void 0;
var name_1 = require("../utils/name");
exports.BUILD_NAME = "BUILD_NAME";
exports.CHANGE_NAME = "CHANGE_NAME";
exports.CHANGE_RISK_LEVEL = "CHANGE_RISK_LEVEL";
function changeName(nameInfo) {
    return {
        type: [exports.CHANGE_NAME],
        firstName: nameInfo.firstName,
        lastName: nameInfo.lastName,
        secondLastName: nameInfo.secondLastName,
        metadata: nameInfo.metadata,
    };
}
exports.changeName = changeName;
function changeRiskLevel(riskLevelInfo) {
    return {
        type: [exports.CHANGE_RISK_LEVEL],
        userActionRiskLevel: riskLevelInfo,
    };
}
exports.changeRiskLevel = changeRiskLevel;
exports.DefaultState = {
    firstName: "",
    lastName: "",
    secondLastName: "",
    allowMinorNameChange: false,
    nameContentConfigs: new name_1.NameContentConfigs(),
    metadata: {},
    userCiped: false,
    userActionRiskLevel: "low",
    stepUpContextId: "",
    comingFromANW: false,
    stepUpPassed: false,
    hideMailLink: false,
};
